import React, { useState, useEffect } from "react";
import NavBar from "../../components/NavBar/NavBar";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Swal from "sweetalert2";
import { SchoolListAPI, TransferToSchoolWalletAPI } from "../../api/apiHandler";
import Heading from "../../components/Heading/Heading";

const schema = yup.object().shape({
    amount: yup
        .number()
        .typeError("Amount must be a number")
        .positive("Amount must be positive")
        .required("Amount is required"),
    school_id: yup.string().required("Please select a school"),
    notes: yup.string().nullable(),
});

export default function TransferToSchoolWallet() {
    const navigate = useNavigate();
    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
        reset,
    } = useForm({
        resolver: yupResolver(schema),
    });

    const [schools, setSchools] = useState([]);
    const [selectedSchool, setSelectedSchool] = useState(null);
    const donor_data = JSON.parse(localStorage.getItem("DAData"));
    const donor_id = donor_data?.id || localStorage.getItem("DAid");
    const wallet_id = donor_data?.wallet_id;

    useEffect(() => {
        fetchSchools();
    }, []);

    const fetchSchools = async () => {
        try {
            const response = await SchoolListAPI();
            const schoolData = response?.data?.data || [];
            setSchools(schoolData);
        } catch (error) {
            console.error("Error fetching schools:", error);
            setSchools([]);
        }
    };

    const schoolOptions = schools.map((s) => ({
        value: String(s?.id || ""),
        label: s?.school_name || "Unknown School",
    }));

    const onSubmit = async (data) => {
        const req = {
            donor_id: donor_id,
            wallet_id: wallet_id,
        };
        const requestData = { ...data, ...req };

        console.log("Final Request:", requestData);
        const response = await TransferToSchoolWalletAPI(requestData);
        console.log("API Response:", response);

        if (response?.data?.code !== "1") { 
            Swal.fire({
                title: "Error",
                text: response?.data?.message || "Something went wrong",
                icon: "error",
            });
            return;
        }


        Swal.fire({
            title: "Transfer Successful!",
            text: `$${data.amount} transferred to selected school wallet.`,
            icon: "success",
        });

        reset();
        setSelectedSchool(null);
    };

    return (
        <>
            <NavBar />
            <section className="content home">
                <Heading title="Transfer To School Wallet" />
                <div className="container-fluid">
                    <div className="row clearfix">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="body">
                                    <div className="col-12 text-left mb-3">
                                        <a
                                            onClick={() => navigate(-1)}
                                            className="btn btn-raised waves-effect waves-float waves-red text-left mr-2"
                                        >
                                            <i className="zmdi zmdi-arrow-left" />
                                        </a>
                                    </div>
                                    <hr />
                                    <div className="row">
                                        <div className="details col-lg-8 col-md-12">
                                            <form onSubmit={handleSubmit(onSubmit)}>
                                                <div className="form-group">
                                                    <div className="form-line">
                                                        <p>Amount</p>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            {...register("amount")}
                                                            min={1}
                                                            placeholder="Enter Amount"
                                                        />
                                                    </div>
                                                    <p className="mt-2 font-bold col-red">
                                                        {errors.amount?.message}
                                                    </p>
                                                </div>

                                                <div className="form-group mt-2">
                                                    <label className="form-label fw-semibold">
                                                        Select School
                                                    </label>
                                                    <Select
                                                        options={schoolOptions}
                                                        value={selectedSchool}
                                                        onChange={(selected) => {
                                                            setSelectedSchool(selected);
                                                            setValue("school_id", selected?.value, {
                                                                shouldValidate: true,
                                                            });
                                                        }}
                                                        placeholder="Select School"
                                                        classNamePrefix="react-select"
                                                    />
                                                    <p className="mt-2 font-bold col-red">
                                                        {errors.school_id?.message}
                                                    </p>
                                                </div>

                                                <div className="form-group">
                                                    <div className="form-line">
                                                        <p>Short Note</p>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            {...register("notes")}
                                                            placeholder="Enter note (optional)"
                                                        />
                                                    </div>
                                                </div>

                                                <button
                                                    type="submit"
                                                    className="btn btn-raised btn-primary m-t-15 m-b-15 waves-effect"
                                                >
                                                    Transfer To School Wallet
                                                </button>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
